export default __webpack_public_path__ + "static/media/11.36ce0749.png";